import styled, {css} from 'styled-components';
import {Link} from 'react-router-dom';

const cardBaseStyles = css`
  display: flex;
  flex-direction: column;
  position: relative;
  border-radius: 16px;
  box-shadow: 0 3px 6px 0 #00000012;
  background: ${props => props.theme.colors.branding.boxesModals};
  overflow: hidden;
  text-decoration: none;
  width: 100%;
  max-width: none;
  height: 100%;
  cursor: pointer;

  @media (hover: hover) {
    &:hover img {
      transform: scale(1.06);
    }
  }
`;

export const Container = styled(Link)`
  ${cardBaseStyles}
`;

export const ExternalContainer = styled.a`
  ${cardBaseStyles}
`;

export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 150px;
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 220ms ease;
`;

export const CategoryBadge = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: ${({theme}) => theme.colors.branding.backgroundSecondary};
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  color: ${({theme}) => theme.colors.branding.fontPrimary};
`;

export const StatusBadgeWrapper = styled.div`
  position: absolute;
  top: 48px;
  right: 12px;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 14px;
  box-sizing: border-box;
  height: 150px;
  flex: 0 0 150px;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

export const Title = styled.div`
  font-family: ${({theme}) => theme.fonts.fontFamily.titles.font_name};
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  color: ${({theme}) => theme.colors.branding.fontPrimary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Highlight = styled.div`
  font-family: ${({theme}) => theme.fonts.fontFamily.titles.font_name};
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  color: ${({theme}) => theme.colors.branding.fontSecondary};
  display: -webkit-box;
  word-wrap: break-word;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
`;

export const Price = styled.div`
  font-family: ${({theme}) => theme.fonts.fontFamily.titles.font_name};
  font-size: 15px;
  font-weight: 600;
  line-height: 20px;
  color: ${({theme}) => theme.colors.branding.fontPrimary};
  margin-top: auto;
  padding-top: 8px;
`;
